import fuzzy from './fuzzy';

export default fuzzy;
